import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeader } from "@/components/RevenueEngine";

const FAQS = [
  {
    q: "We already have someone managing our CRM internally.",
    a: "Good. That person will benefit from having a properly built system under them instead of one they've been patching for years. We build the infrastructure — they maintain and operate it. We're not replacing anyone. We're giving your internal team something that actually works.",
  },
  {
    q: "We've worked with RevOps consultants before and nothing changed.",
    a: "That's almost always because the deliverable was advice. A framework. A deck. We don't do that. The deliverable is a working system — configured, tested, documented, and running in your CRM before we leave. There's nothing to implement after the fact because it's already implemented.",
  },
  {
    q: "We want results fast — not in six months.",
    a: "Most teams see the first meaningful shift within 2–3 weeks of build completion — cleaner pipeline data, faster lead routing, signal-triggered outreach running without manual input. The compounding effect takes 60–90 days. The full picture usually shows clearly by quarter end.",
  },
  {
    q: "What tools do you work with?",
    a: "We're tool-agnostic on the outcome side. We work across HubSpot, Salesforce, Clay, Apollo, n8n, Make, Instantly, Smartlead, Lemlist, RB2B, Fibbler, and most enrichment and signal tools. We won't recommend switching tools unless switching is clearly the right call.",
  },
  {
    q: "We're not sure if now is the right time.",
    a: "That's exactly who the strategy session is for. We'll look at where you are, tell you honestly whether now is the right time, and if it is, what would make the most sense to start with. If it's not the right time, we'll tell you that too. No pressure.",
  },
  {
    q: "What does an engagement look like and what's the commitment?",
    a: "Every engagement is scoped to your specific situation. We cover scope, timeline, and structure on the strategy call, once we've looked at your actual setup. What we don't do is vague retainers with ambiguous outputs. Everything we build has a defined end state.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#050505] border-t border-white/10 py-28 md:py-40"
    >
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <SectionHeader
          overline="Common Questions / 08"
          title={<>Questions you<br /><span className="italic font-light text-white">might be</span> thinking.</>}
          sub="Straight answers. No diplomatic language."
        />

        <div className="mt-12 max-w-4xl">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="border-t border-white/10 last:border-b"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left hover:no-underline group">
                  <div className="flex items-center gap-6 flex-1">
                    <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display font-bold uppercase tracking-tighter text-white text-lg md:text-xl lg:text-2xl group-hover:text-[#CCFF00] transition-colors">
                      {item.q}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="font-body text-zinc-400 text-[15px] leading-relaxed pb-8 pl-16 pr-4 max-w-[70ch]">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
